var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.666,
    height: 20.666,
    viewBox: "0 0 20.666 20.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_5279120_play_video_youtube_youtuble_logo_icon",
    "data-name": "5279120_play_video_youtube_youtuble logo_icon",
    d: "M10.333,0A10.333,10.333,0,1,1,0,10.333,10.338,10.338,0,0,1,10.333,0Zm6.188,7.224a1.617,1.617,0,0,0-1.142-1.142,38.6,38.6,0,0,0-5.046-.27,38.6,38.6,0,0,0-5.046.27A1.618,1.618,0,0,0,4.145,7.224a16.813,16.813,0,0,0-.27,3.109,16.811,16.811,0,0,0,.27,3.109,1.618,1.618,0,0,0,1.142,1.142,38.612,38.612,0,0,0,5.046.27,38.612,38.612,0,0,0,5.046-.27,1.618,1.618,0,0,0,1.142-1.142,16.812,16.812,0,0,0,.27-3.109,16.813,16.813,0,0,0-.27-3.109ZM9.041,12.27V8.4L12.4,10.333,9.041,12.27Z",
    fill: "#e4c7ff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.06fc44741e0d609bdbb68bda56311a68.svg";
export { ForwardRef as ReactComponent };